import React from 'react';
import { Badge, Button, Grid, Typography } from '@mui/material';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import palette from '../../../views/App/palette.scss';

const DEFAULT_COLOR = palette.primaryMain;
const BORDER_RADIUS = 6;

const FullHeightStyle = {
  height: '100%'
};

const ButtonStyle = {
  borderRadius: BORDER_RADIUS,
  background: '#fff',
  padding: 0
};

const BorderGridStyle = {
  width: 6,
  alignSelf: 'stretch',
  borderRadius: `${BORDER_RADIUS}px 0 0 ${BORDER_RADIUS}px`
};

const LabelGridStyle = {
  flexGrow: 1,
  position: 'relative'
};

const LabelTypoContainerStyle = {
  ...FullHeightStyle,
  width: '100%',
  padding: 8
};

const ArrowGridStyle = {
  width: 22,
  color: '#fff',
  borderRadius: `0 ${BORDER_RADIUS}px ${BORDER_RADIUS}px 0`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const IconStyle = {
  fontSize: 35,
  verticalAlign: 'middle'
};

const ArrowIconContainerStyle = {
  ...FullHeightStyle,
  width: '100%'
};

const RedDotStyle = {
  position: 'absolute',
  top: 8,
  right: 8
};

const GuidanceButton = props => {
  const { label, labelProps, color, redDot, onClick } = props;

  return (
    <Button variant="contained" color="primary" fullWidth={true} onClick={onClick} style={ButtonStyle}>
      <Grid container wrap="nowrap" style={{ width: '100%' }}>
        <Grid style={{ ...BorderGridStyle, background: color || DEFAULT_COLOR }} />
        <Grid size="grow" style={{ position: 'relative' }}>
          {redDot && <Badge color="error" variant="dot" style={RedDotStyle} />}
          <Grid container style={LabelTypoContainerStyle} sx={{
            alignItems: "center"
          }}>
            <Grid>
              <Typography color="textSecondary" {...labelProps}>
                {label}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid style={{ ...ArrowGridStyle, background: color || DEFAULT_COLOR }}>
          <ArrowRightRoundedIcon style={IconStyle} />
        </Grid>
      </Grid>
    </Button>
  );
};

export default GuidanceButton;
